import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables';
import { AUDITING_API } from '@Constants/backendConstants';
import { actionEventLogColumns } from '@Constants/TableColumns';
import { EnumFrontendLayoutSetting, type ApiActionEventLog } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { ActionEventLogsRepository } from '@Repositories/Auditing';

export function FrameListActionEventLog() {
    const { loadPage } = useListApi(ActionEventLogsRepository, AUDITING_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiActionEventLog>
            layoutSettingsContext={EnumFrontendLayoutSetting.ActionEventLogsTableLayout}
            name="ActionEventLogsList"
            columns={actionEventLogColumns}
            initialSorting={{ columnName: 'created_at', direction: 'desc' }}
            loader={loadPage}
            canCreate={false}
            useOnClickNavigation
            fullSize
        />
    );
}
